import * as React from 'react';
import BlackFriday from '~/customization/BlackFriday/Category/BlackFriday';
import { CategoryThemes } from '~/types/category';

interface IContentLayoutDecoration {
    theme: CategoryThemes;
    categoryName: ICategoryList;
    children: React.ReactChild | React.ReactChild[];
}

const ContentLayoutDecoration = ({ theme, children, categoryName }: IContentLayoutDecoration) => {
    switch (theme) {
        case CategoryThemes.BLACK_FRIDAY_THEME: {
            return <BlackFriday categoryName={categoryName}>{children}</BlackFriday>;
        }

        default: {
            return <React.Fragment>{children}</React.Fragment>;
        }
    }
};

export default ContentLayoutDecoration;
